/* sf-search.js: typo help for the search panel and the /search page.
   Reads a small collection index (sections/sf-search-index.liquid), caches it in localStorage,
   and finds the nearest brewery or style when a search has no real match.
   Panel: watches #spResults for data-nomatch and data-sfweak (set by sections/sf-search-suggest.liquid).
   Page: looks for [data-sf-nomatch] (set by sections/sf-search.liquid). */
(function () {
  'use strict';

  var CACHE_KEY = 'sf_search_idx';
  var TTL = 12 * 3600 * 1000;
  var STOP = {};
  ('sake nihonshu nama shuzo shuzou shuzoh jozo brewery brewing inc co the and of no junmai ginjo daiginjo honjozo ' +
   'futsu futsushu koshu genshu muroka nigori okan kan namazake').split(' ').forEach(function (w) { STOP[w] = 1; });
  var STOP_TOKEN = { sake: 1, shuzo: 1, shuzou: 1, shuzoh: 1, jozo: 1, brewery: 1, brewing: 1, inc: 1, nihonshu: 1 };

  /* ---------- text helpers ---------- */
  function esc(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  function norm(s) {
    s = String(s || '').toLowerCase();
    try { s = s.normalize('NFD').replace(/[̀-ͯ]/g, ''); } catch (e) {}
    s = s.replace(/[^a-z0-9]/g, '');
    return s.replace(/ou/g, 'o').replace(/uu/g, 'u').replace(/oo/g, 'o');
  }
  function slug(s) {
    return String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }
  function cap(s) {
    return String(s).replace(/\b[a-z]/g, function (c) { return c.toUpperCase(); });
  }
  function handleOf(it) {
    var m = /\/collections\/([^\/?#]+)/.exec(it.u || '');
    return m ? m[1] : '';
  }
  function termFor(it) {
    var h = handleOf(it);
    return slug(it.t) === h ? it.t : h;
  }

  /* Damerau-Levenshtein (optimal string alignment) */
  function dl(a, b) {
    var al = a.length, bl = b.length, i, j, d = [], cost;
    for (i = 0; i <= al; i++) { d[i] = [i]; }
    for (j = 0; j <= bl; j++) { d[0][j] = j; }
    for (i = 1; i <= al; i++) {
      for (j = 1; j <= bl; j++) {
        cost = a.charAt(i - 1) === b.charAt(j - 1) ? 0 : 1;
        d[i][j] = Math.min(d[i - 1][j] + 1, d[i][j - 1] + 1, d[i - 1][j - 1] + cost);
        if (i > 1 && j > 1 && a.charAt(i - 1) === b.charAt(j - 2) && a.charAt(i - 2) === b.charAt(j - 1)) {
          d[i][j] = Math.min(d[i][j], d[i - 2][j - 2] + 1);
        }
      }
    }
    return d[al][bl];
  }
  function tri(a, b) {
    var seen = {}, n = 0, i;
    for (i = 0; i + 3 <= a.length; i++) { seen[a.substr(i, 3)] = 1; }
    for (i = 0; i + 3 <= b.length; i++) { if (seen[b.substr(i, 3)]) { n++; seen[b.substr(i, 3)] = 0; } }
    return n;
  }

  /* ---------- index ---------- */
  var ENTRIES = null;      // [{it, keys:[{k, ty, disp}]}]
  var waiting = null;
  var tries = 0;

  function build(items) {
    var out = [];
    items.forEach(function (it) {
      var keys = [], seen = {};
      function add(raw, ty) {
        var k = norm(raw);
        if (k.length < 3 || seen[ty + k]) { return; }
        if (ty === 'p' && STOP[k]) { return; }
        seen[ty + k] = 1;
        keys.push({ k: k, ty: ty, disp: String(raw).trim() });
      }
      var base = String(it.t).split('(')[0].trim();
      var shortT = norm(base.replace(/ (Shuzou|Shuzo|Jozo|Brewery|Inc\.?)/g, ''));
      add(base, 't');
      String(it.a || '').split('|').forEach(function (a, i) {
        if (!a) { return; }
        add(a, i === 0 ? 'h' : (norm(a) === shortT ? 't' : 'p'));
      });
      String(it.s || '').split('|').forEach(function (a) { if (a) { add(a, 's'); } });
      out.push({ it: it, keys: keys });
    });
    return out;
  }

  function parseSection(json) {
    var html = json && json['sf-search-index'];
    if (!html) { return null; }
    var box = document.createElement('div');
    box.innerHTML = html;
    var s = box.querySelector('#sf-search-index');
    return s ? JSON.parse(s.textContent) : null;
  }
  function fetchPage(n) {
    return fetch('/?sections=sf-search-index' + (n > 1 ? '&page=' + n : ''), { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); }).then(parseSection);
  }
  function fetchIndex() {
    return fetchPage(1).then(function (first) {
      if (!first) { throw new Error('no index'); }
      var more = [], i;
      for (i = 2; i <= (first.pages || 1); i++) { more.push(fetchPage(i)); }
      return Promise.all(more).then(function (rest) {
        var items = first.items.slice();
        rest.forEach(function (p) { if (p && p.items) { items = items.concat(p.items); } });
        return { v: first.v, t: Date.now(), items: items };
      });
    });
  }
  function readCache() {
    try {
      var c = JSON.parse(localStorage.getItem(CACHE_KEY) || 'null');
      if (c && c.items && c.items.length && Date.now() - c.t < TTL) { return c; }
    } catch (e) {}
    return null;
  }
  function writeCache(c) {
    try { localStorage.setItem(CACHE_KEY, JSON.stringify(c)); } catch (e) {}
  }
  function loadIndex(cb) {
    if (ENTRIES) { cb(ENTRIES); return; }
    if (waiting) { waiting.push(cb); return; }
    waiting = [cb];
    function done(items) {
      ENTRIES = build(items);
      var w = waiting; waiting = null;
      w.forEach(function (f) { try { f(ENTRIES); } catch (e) {} });
    }
    var c = readCache();
    if (c) { done(c.items); return; }
    if (!window.fetch || !window.Promise) { waiting = null; return; }
    (function go() {
      fetchIndex().then(function (res) { writeCache(res); done(res.items); }).catch(function () {
        tries++;
        if (tries < 3) { setTimeout(go, 1200 * tries); } else { waiting = null; tries = 0; }
      });
    })();
  }

  /* ---------- matching ---------- */
  function scoreAll(entries, nq, isStop) {
    var best = null;
    entries.forEach(function (e) {
      e.keys.forEach(function (key) {
        var k = key.k, sc = 0, d = 0, max;
        if (k === nq) {
          if (isStop && key.ty !== 'h' && key.ty !== 's') { return; }
          sc = 4;
        } else if (isStop || key.ty === 's') {
          return;
        } else if (k.length > nq.length && k.indexOf(nq) === 0) {
          sc = 3; d = k.length - nq.length;
        } else {
          max = nq.length >= 8 ? 2 : (nq.length >= 4 ? 1 : 0);
          if (!max || k.length < 4 || Math.abs(k.length - nq.length) > max) { return; }
          d = dl(nq, k);
          if (d > max) { return; }
          sc = 2;
        }
        var t = tri(nq, k), n = e.it.n || 0;
        var better = !best || sc > best.sc || (sc === best.sc && (d < best.d || (d === best.d && (t > best.t || (t === best.t && n > best.n)))));
        if (better) { best = { sc: sc, d: d, t: t, n: n, it: e.it, key: key }; }
      });
    });
    return best;
  }
  function sfMatch(q, entries) {
    entries = entries || ENTRIES;
    if (!entries) { return null; }
    var nq = norm(q);
    if (nq.length < 3) { return null; }
    var best = scoreAll(entries, nq, !!STOP[nq]);
    if (!best) {
      // "ichinokura sake", "kubota shuzo": drop filler words and try again
      var toks = String(q).toLowerCase().split(/\s+/), keep = [];
      toks.forEach(function (t) { if (!STOP_TOKEN[t]) { keep.push(t); } });
      var n2 = norm(keep.join(''));
      if (keep.length && keep.length < toks.length && n2.length >= 3) { best = scoreAll(entries, n2, !!STOP[n2]); }
    }
    if (!best) { return null; }
    return {
      item: best.it,
      kind: best.sc === 4 ? 'exact' : (best.sc === 3 ? 'prefix' : 'fuzzy'),
      type: best.key.ty,
      name: best.key.disp,
      handle: handleOf(best.it),
      term: best.key.ty === 'p' ? best.key.disp : termFor(best.it)
    };
  }
  window.sfMatch = function (q) { return sfMatch(q); };
  window.sfSearchIndex = loadIndex;

  /* ---------- copy (shared by the panel and the page) ---------- */
  function noteHtml(m, q) {
    var it = m.item, link = '<a href="' + esc(it.u) + '">';
    var brand = m.type === 'p' || m.type === 'h' ? cap(m.name) : it.t;
    var title = String(it.t);
    if (!it.n) {
      var s = '<strong>No ' + esc(cap(m.name)) + ' bottles right now.</strong>';
      if (cap(m.name) !== title.split('(')[0].trim()) { s += ' The brewery is ' + link + esc(title) + '</a>.'; }
      return s;
    }
    if (m.type === 'p') {
      var nm = cap(m.name), why = '<strong>Did you mean <a href="/search?q=' + encodeURIComponent(nm) + '">' + esc(nm) + '</a>?</strong> Showing ' + esc(nm) + ' bottles.';
      if (m.kind === 'exact') { return 'Showing ' + esc(nm) + ' bottles.'; }
      return why + ' <a data-sf-orig="1" href="/search?q=' + encodeURIComponent(q) + '&amp;sf_exact=1&amp;options%5Bunavailable_products%5D=last">Search for &ldquo;' + esc(q) + '&rdquo; instead.</a>';
    }
    if (m.type === 's') { return 'Showing ' + link + esc(title) + '</a> for &ldquo;' + esc(q) + '&rdquo;.'; }
    if (m.kind === 'exact') { return 'Showing bottles from ' + link + esc(title) + '</a>.'; }
    var s2 = '<strong>Did you mean ' + link + esc(brand) + '</a>?</strong> Showing bottles from ' + esc(title) + '.';
    return s2 + ' <a data-sf-orig="1" href="/search?q=' + encodeURIComponent(q) + '&amp;sf_exact=1&amp;options%5Bunavailable_products%5D=last">Search for &ldquo;' + esc(q) + '&rdquo; instead.</a>';
  }

  /* ---------- search panel ---------- */
  function initPanel() {
    var res = document.getElementById('spResults'), inp = document.getElementById('spInput');
    if (!res || !inp || !window.MutationObserver || !window.fetch) { return; }
    var warmed = false;
    inp.addEventListener('focus', function () { if (!warmed) { warmed = true; loadIndex(function () {}); } });

    function handle(mk, weak) {
      var q = (mk.getAttribute('data-q') || '').trim();
      var have = weak ? (parseInt(mk.getAttribute('data-n'), 10) || 0) : 0;
      if (!q) { return; }
      loadIndex(function (entries) {
        if (!res.contains(mk) || inp.value.trim().toLowerCase() !== q.toLowerCase()) { return; }
        var m = sfMatch(q, entries);
        if (!m) { return; }
        // a few weak hits ("nabe"): same rule as the /search page, only a longer brewery or brand name with more bottles counts
        if (weak && (m.kind !== 'prefix' || m.type === 's' || !m.item.n || m.item.n <= have)) { return; }
        var note = '<div class="sp-dym" data-sfdone="1">' + noteHtml(m, q) + '</div>';
        if (!m.item.n) {
          // brand with nothing to sell: keep the empty state's popular links, swap the first line
          var pop = res.querySelector('.sp-pop');
          res.innerHTML = note + (pop ? pop.outerHTML : '');
          return;
        }
        var url = '/search/suggest?q=' + encodeURIComponent(m.term) + '&section_id=sf-search-suggest&resources[type]=product,collection,page,article&resources[limit]=6&resources[options][unavailable_products]=last';
        fetch(url, { headers: { Accept: 'text/html' } }).then(function (r) { return r.text(); }).then(function (t) {
          if (!res.contains(mk) || inp.value.trim().toLowerCase() !== q.toLowerCase()) { return; }
          var tmp = document.createElement('div');
          tmp.innerHTML = t;
          var inner = tmp.querySelector('.sp-suggest');
          var body = inner ? inner.innerHTML : '';
          var again = tmp.querySelector('[data-nomatch]');
          if (weak && (again || !body)) { return; }
          if (again || !body) {
            body = '<a class="sp-all" href="' + esc(m.item.u) + '">See the ' + esc(m.item.t) + ' collection &rarr;</a>';
          }
          var box = document.createElement('div');
          box.innerHTML = body;
          Array.prototype.forEach.call(box.querySelectorAll('[data-nomatch]'), function (n) { n.removeAttribute('data-nomatch'); });
          Array.prototype.forEach.call(box.querySelectorAll('[data-sfweak]'), function (n) { n.setAttribute('data-sfdone', '1'); });
          var holder = document.createElement('div');
          holder.innerHTML = note;
          Array.prototype.forEach.call(holder.querySelectorAll('[data-nomatch]'), function (n) { n.removeAttribute('data-nomatch'); });
          res.innerHTML = holder.innerHTML + box.innerHTML;
          res.scrollTop = 0;
        }).catch(function () {});
      });
    }

    var obs = new MutationObserver(function () {
      var mk = res.querySelector('[data-nomatch="1"]'), weak = false;
      if (!mk) { mk = res.querySelector('[data-sfweak="1"]'); weak = !!mk; }
      if (!mk || mk.getAttribute('data-sfdone')) { return; }
      mk.setAttribute('data-sfdone', '1');
      handle(mk, weak);
    });
    obs.observe(res, { childList: true, subtree: true });
  }

  /* ---------- /search page ---------- */
  function initPage() {
    var root = document.querySelector('.srch');
    if (!root) { return; }
    var t = root.getAttribute('data-sf-title');
    if (t) {
      var parts = document.title.split(' — '), tail = parts.length > 1 ? parts[parts.length - 1] : '';
      document.title = t + (tail ? ' — ' + tail : '');
      var og = document.querySelector('meta[property="og:title"]');
      if (og) { og.setAttribute('content', t); }
    }
    var mk = root.querySelector('[data-sf-nomatch="1"]');
    var weak = !mk ? root.querySelector('[data-sf-weak="1"]') : null;
    var anchor = mk || weak;
    if (!anchor || /[?&]sf_exact=1/.test(location.search) || !window.fetch) { return; }
    var q = (anchor.getAttribute('data-q') || '').trim();
    var have = weak ? (parseInt(weak.getAttribute('data-n'), 10) || 0) : 0;
    if (!q) { return; }
    loadIndex(function (entries) {
      var m = sfMatch(q, entries);
      if (!m) { return; }
      // a few weak hits ("ichino"): only a longer brewery or brand name that has more bottles counts
      if (weak && (m.kind !== 'prefix' || m.type === 's' || !m.item.n || m.item.n <= have)) { return; }
      var note = document.createElement('div');
      note.className = 'srch-alias srch-dym';
      note.setAttribute('role', 'status');
      note.innerHTML = noteHtml(m, q);
      var line = mk ? mk.querySelector('.srch-none-l') : null;
      if (!m.item.n) {
        if (line) { line.innerHTML = noteHtml(m, q); }
        return;
      }
      var next = '/search?q=' + encodeURIComponent(m.term) + '&options%5Bunavailable_products%5D=last';
      // show the note now, then swap the page for the corrected results when they arrive
      anchor.parentNode.insertBefore(note, anchor);
      fetch(next, { headers: { Accept: 'text/html' } }).then(function (r) { return r.text(); }).then(function (h) {
        var doc = new DOMParser().parseFromString(h, 'text/html');
        var fresh = doc.querySelector('.srch');
        if (!fresh || fresh.querySelector('[data-sf-nomatch="1"]')) { return; }
        root.innerHTML = fresh.innerHTML;
        Array.prototype.forEach.call(root.querySelectorAll('.rv'), function (n) { n.classList.add('in'); });
        var body = root.querySelector('.srch-body');
        if (body) { body.parentNode.insertBefore(note, body); }
        try { history.replaceState(null, '', next); } catch (e) {}
        var ft = fresh.getAttribute('data-sf-title');
        if (ft) {
          var parts = document.title.split(' — '), tail = parts.length > 1 ? parts[parts.length - 1] : '';
          document.title = ft + (tail ? ' — ' + tail : '');
        }
      }).catch(function () {
        note.innerHTML = '<strong>Did you mean <a href="' + esc(next) + '">' + esc(m.item.t) + '</a>?</strong>';
      });
    });
  }

  function init() {
    initPanel();
    initPage();
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();
